import { HttpErrorResponse, HttpEvent, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AppAuthService } from '../services/app-auth.service';
import { AppSessionService } from '../session/app-session.service';
import { BehaviorSubject, catchError, Observable, switchMap, throwError } from 'rxjs';

const isRefreshingToken = new BehaviorSubject<boolean>(false);
const refreshTokenSubject = new BehaviorSubject<any>(null);

export const authInterceptor: HttpInterceptorFn = (req, next): Observable<HttpEvent<unknown>> => {
  const authService = inject(AppAuthService);
  const sessionService = inject(AppSessionService);

  const authToken = sessionService.accessToken;

  const authReq = authToken ? addTokenHeader(req, authToken) : req;

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {

      console.log('error Interceptor', error);


      if (error.status === 401 && !req.url.includes('/api/auth/refresh')) {
        if (!isRefreshingToken.value) {
          isRefreshingToken.next(true);
          refreshTokenSubject.next(null);

          return authService.refreshToken().pipe(
            switchMap((response) => {
              isRefreshingToken.next(false);
              refreshTokenSubject.next(response.accessToken);

              return next(addTokenHeader(req, response.accessToken!));
            }),
            catchError((err) => {
              isRefreshingToken.next(false);
              console.log('Error refreshing token', err);
              return throwError(() => err);
            })
          );
        } else {
          return refreshTokenSubject.pipe(
            switchMap((token) => {
              if (token) {
                return next(addTokenHeader(req, token!));
              } else {
                return throwError(() => new Error('Refresh token not available.'));
              }
            }),
            catchError((err) => {
              console.log('Error waiting for token', err);
              return throwError(() => err);
            })
          );
        }
      }

      return throwError(() => error);
    })
  );
};

const addTokenHeader = (req: HttpRequest<unknown>, token: string) => {
  return req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  });
};